'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AlertIconXs } from '@lichtblick/icons/svg/alert/alert-xs';
import { BoxCTA } from '@lichtblick/photon/atoms/box-cta/box-cta';
import { FieldFooter } from '@lichtblick/photon/atoms/field-footer';
import { Checkbox } from '@lichtblick/photon/molecules/checkbox';
import { Textfield } from '@lichtblick/photon/molecules/textfield';
import { useActionState, useEffect, useRef } from 'react';
import { InfoTeaser } from '../info-teaser/info-teaser';
import { submitAction } from './action';
import styles from './b2c-commodity-lead-form.module.scss';
const REQUIRED_ERROR_MESSAGE = 'Hier fehlt noch eine Angabe';
export const Form = ({ optinTextAsString, optinText, successTeaser, marketingCampaignIdentifier })=>{
    const containerRef = useRef(null);
    const formRef = useRef(null);
    const [state, dispatch, pending] = useActionState(submitAction, {
        error: false,
        success: false,
        data: {
            email: '',
            fullname: '',
            phone: '',
            optin: false
        }
    });
    useEffect(()=>{
        if (state.success) {
            containerRef.current?.scrollIntoView({
                block: 'center'
            });
        }
        if (!state.success && state.error) {
            formRef.current?.scrollIntoView({
                block: 'center'
            });
        }
    }, [
        state.success,
        state.error
    ]);
    if (state.success) {
        return /*#__PURE__*/ _jsx("div", {
            ref: containerRef,
            children: /*#__PURE__*/ _jsx(InfoTeaser, {
                ...successTeaser
            })
        });
    }
    return /*#__PURE__*/ _jsxs("form", {
        action: dispatch,
        className: styles.form,
        ref: formRef,
        children: [
            /*#__PURE__*/ _jsx("input", {
                type: "hidden",
                name: "marketingCampaignIdentifier",
                value: marketingCampaignIdentifier
            }),
            /*#__PURE__*/ _jsx("input", {
                type: "hidden",
                name: "optinText",
                value: optinTextAsString
            }),
            /*#__PURE__*/ _jsx(Textfield, {
                label: "Name",
                defaultValue: state.data.fullname,
                name: "fullname",
                type: "text",
                errorMessage: REQUIRED_ERROR_MESSAGE,
                required: true
            }),
            /*#__PURE__*/ _jsx(Textfield, {
                label: "E-Mail-Adresse",
                defaultValue: state.data.email,
                name: "email",
                type: "email",
                required: true,
                errorMessage: REQUIRED_ERROR_MESSAGE
            }),
            /*#__PURE__*/ _jsx(Textfield, {
                label: "Telefonnummer (optional)",
                defaultValue: state.data.phone,
                name: "phone",
                type: "tel",
                pattern: "^(?:\\+\\d|0)(?: ?(- ?)?\\d){5,}$",
                errorMessage: "Bitte achte darauf, dass die Telefonnummer mit einem + oder einer 0 startet, mindestens 6 Ziffern hat und mit einer Ziffer endet."
            }),
            /*#__PURE__*/ _jsx(Checkbox, {
                errorMessage: REQUIRED_ERROR_MESSAGE,
                label: /*#__PURE__*/ _jsx(Checkbox.Label, {
                    children: optinText
                }),
                children: /*#__PURE__*/ _jsx(Checkbox.Checkbox, {
                    defaultChecked: state.data.optin,
                    name: "optin",
                    required: true
                })
            }),
            state.error && !pending && /*#__PURE__*/ _jsx(FieldFooter, {
                className: styles.error,
                error: true,
                icon: /*#__PURE__*/ _jsx(AlertIconXs, {}),
                children: "Beim Senden der Anfrage ist ein unerwarteter Fehler aufgetreten. Bitte versuche es später noch einmal."
            }),
            /*#__PURE__*/ _jsx(BoxCTA, {
                as: "button",
                type: "submit",
                loading: pending,
                children: "Absenden"
            })
        ]
    });
};

//# sourceMappingURL=form.js.map